import React from 'react';
import { REDUCER_NAME } from './../../reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BuySellButton from './../../../common/group-button';
import { withComponentId } from './../../../../common/ComponentIdContext';

class indexSumary extends React.Component {
  render() {
    const { currentSearch } = this.props;

    if (currentSearch && !currentSearch.isTicker) {
      return (
        <div className="group-button d-flex align-items-center justify-content-between flex-row mr-3" />
      );
    }

    return <BuySellButton code={currentSearch.displayCode} />;
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(indexSumary);
